import styled from 'styled-components'

export const SmartEditContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: 24px;
`

export const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const ImageWrapper = styled.div`
  position: relative;
  & > :first-child {
    border-bottom: none;
  }
`

export const Divider = styled.div`
  flex-shrink: 0;
  height: 1px;
  background: linear-gradient(
    270deg,
    rgba(221, 227, 240, 0) 0%,
    #dde3f0 50%,
    rgba(221, 227, 240, 0) 100%
  );
`
